import Button from "components/common/buttons/buttons";
import { useSession } from "next-auth/react";
import { useEffect, useMemo } from "react";
import { TYPO } from "styles/Typo";
import {
  useDetailAlarmClick,
  useDetailInterestClick,
} from "../../Header/Buttons/DetailHeaderBtnsClick";
import CustomToast from "components/atoms/CustomToast";
import { useRouter } from "next/router";
import { useStockAlarm } from "lib/analytics/react/hooks";

function DetailAINewsRaderAlarmCTA({ detailData }: { detailData: any }) {
  const router = useRouter();
  const stockAlarm = useStockAlarm();
  const {
    isAlarmRegistered,
    handleAlarmClick,
    alarmSuccessToastVisible,
    setAlarmSuccessToastVisible,
  } = useDetailAlarmClick();
  const {
    isInterested,
    handleStarClick,
    interestToastVisible,
    setInterestToastVisible,
    interestErrorToastVisible,
  } = useDetailInterestClick();

  useEffect(() => {
    if (alarmSuccessToastVisible) {
      stockAlarm.success();
    }
  }, [alarmSuccessToastVisible]);

  return (
    <div className="py-[72px] px-6 flex flex-col gap-[14px] justify-center items-center text-center">
      <div className=" flex flex-col justify-center items-center text-center">
        <p className={`${TYPO.TYPO7_1_MD} text-gray50`}>아직 뉴스가 없어요</p>
        <p className={`${TYPO.TYPO6_MD} text-gray80 whitespace-pre-line`}>
          {!isInterested
            ? `관심으로 등록하면\n뉴스를 문자로 보내드려요`
            : !isAlarmRegistered
            ? `새로운 소식이 뜨면\n문자로 보내드릴까요?`
            : `새로운 소식이 뜨면\n문자로 보내드릴게요`}
        </p>
      </div>
      {(!isInterested || !isAlarmRegistered) && (
        <Button
          size="md"
          width="w-fit"
          type="secondary"
          text={
            !isInterested ? "등록하기" : !isAlarmRegistered ? "알림 받기" : ""
          }
          clickHandler={() => {
            stockAlarm.start({
              ticker: detailData?.ITEM_CD_DL,
              market: detailData?.LOC === "kr" ? "kr" : "us",
              from_section_id: "stock_feed_news",
            });
            if (!isInterested) {
              handleStarClick();
            } else if (!isAlarmRegistered) {
              handleAlarmClick(stockAlarm.success, stockAlarm.fail);
            }
            return;
          }}
        />
      )}
      <CustomToast
        message={
          router.locale == "ko"
            ? isInterested
              ? "관심 자산으로 추가됐어요"
              : "관심 자산이 삭제됐어요"
            : isInterested
            ? "Successfully added"
            : "Successfully deleted"
        }
        isVisible={interestToastVisible && !interestErrorToastVisible}
        onClose={() => setInterestToastVisible(false)}
        width={
          isInterested
            ? router.locale === "ko"
              ? 220
              : 205
            : router.locale === "ko"
            ? 205
            : 210
        }
      />
      <CustomToast
        message={
          router.locale == "ko" && isAlarmRegistered
            ? "이제부터 문자로 알림을 받아요"
            : isAlarmRegistered &&
              router.locale !== "ko" &&
              "Successfully Alarm Registered"
        }
        isVisible={alarmSuccessToastVisible && isAlarmRegistered}
        onClose={() => setAlarmSuccessToastVisible(false)}
        width={router.locale === "ko" ? 255 : 275}
        successIconFill={"#34BB7A"}
        customAnimation="bottom-toast-detail-alarm-register"
        duration={2000}
      />
    </div>
  );
}
export default DetailAINewsRaderAlarmCTA;
